import { useEffect, useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Preloader from '@/components/UI/Preloader';
import { prettyDate } from '@/helpers/date';
import { DATE_FORMAT_DD_MMM_YYYY } from '@/helpers/common';
import { prettyFloatMoney } from '@/helpers/utils';
import { useGetRepaymentDetailByDeadline } from '@/query/queries/cash/useGetRepaymentDetailByDeadline';
import Arrow from '../../assets/icon_arrow.svg';
import IconCalendar from './icon_calendar.svg';
import IconCoins from './icon_coins.svg';
import IconPie from './icon_pie.svg';
import { Table } from '../Table';
import s from './index.module.scss';

export const Row = ({ data }) => {
  const [open, setOpen] = useState(false);
  const { data: repayment, isLoading, refetch } = useGetRepaymentDetailByDeadline(data.deadline);
  const { t } = useTranslation('next-repayment');

  useEffect(() => {
    open && !repayment && refetch();
  }, [open]);

  return (
    <div className={classnames(s.group, open && 'open')}>
      <div className={s.row} onClick={() => setOpen(!open)}>
        <div className={s.block}>
          <div className={s.block_icon}>
            <img src={IconCalendar} alt="icon" width={20} height={20} />
          </div>
          <div className={s.block_content}>
            <div className={classnames(s.block_value, 'f-body-accent')}>
              {prettyDate(data.deadline, DATE_FORMAT_DD_MMM_YYYY)}
            </div>
            <div className={classnames(s.block_label, 'f-tiny-accent')}>
              {t('future_repayments.due_date')}
            </div>
          </div>
        </div>
        <div className={s.block}>
          <div className={s.block_icon}>
            <img src={IconCoins} alt="icon" width={20} height={20} />
          </div>
          <div className={s.block_content}>
            <div className={classnames(s.block_value, 'f-body-accent')}>
              {prettyFloatMoney(data.total_amount)}
            </div>
            <div className={classnames(s.block_label, 'f-tiny-accent')}>
              {t('future_repayments.repayment')}
            </div>
          </div>
        </div>
        <div className={s.block}>
          <div className={s.block_icon}>
            <img src={IconPie} alt="icon" width={20} height={20} />
          </div>
          <div className={s.block_content}>
            <div className={classnames(s.block_value, 'f-body-accent')}>
              {prettyFloatMoney(data.outstanding)}
            </div>
            <div className={classnames(s.block_label, 'f-tiny-accent')}>
              {t('future_repayments.outstanding_amount')}
            </div>
          </div>
        </div>
        <div className="f-small-regular">
          {data.refin_available && t('future_repayments.repayment_is_available_for_refinance')}
        </div>
        <img src={Arrow} alt="arrow" className={s.group_arrow} />
      </div>
      <div className={s.group_dropdown}>
        <div className={s.group_content}>
          {isLoading ? (
            <div className={s.preloader}>
              <Preloader style={{ transform: 'scale(0.7)', minHeight: '60px' }} />
            </div>
          ) : (
            repayment && (
              <div>
                <Table className={s.table} repayment={repayment} />
                {!!repayment?.refin_amount && (
                  <div className={s.refinance}>
                    <div className={classnames(s.refinance_cell, 'f-small-accent')}>Refinanced</div>
                    <div className={classnames(s.refinance_cell, 'f-small-regular')}>
                      -{prettyFloatMoney(repayment.refin_amount)}
                    </div>
                  </div>
                )}
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};
